import React from 'react';
import { ServiceCard } from '../../components/Services';
import { CommonHeader } from '../../components/commons';
import { connect } from 'react-redux';
import { RootState } from '../../redux/rootReducers';
import { useMenuCheck } from '../../customHooks/useMenuCheck';



type AppProps = {
    sideMenus: any[];
    modules: any[];
    history:any;
}



const Services = ({ sideMenus, modules ,history}: AppProps) => {

    //====================User-Management=========================
     const [isServicesPresent,setIsServicesPresent]=useMenuCheck()
     //===========================================================

     
 
    //commented for future use
    // useEffect(()=>{
    //     setIsServicesPresent(url,"url")
    // },[])

    const redirectToAccedDenied = () => {
        history.push({
            pathname: `/access-denied`
        })
    }
    
     
     
    const renderServicesCard = () => {
        let finalServicesCard = sideMenus[1].sub_menu?.map((service: any) => {
            return (
                <ServiceCard
                    key={service.menu_name}
                    serviceTitle={service.menu_name}
                    url={service.front_end_route}
                    comingSoon={!!service.coming_soon}
                />
            )
        });

        return finalServicesCard;
    }

    return (
        <>
            <CommonHeader title="Services" />

            <div className="row">
                {isServicesPresent===false ? redirectToAccedDenied() : renderServicesCard()}
            </div>
        </>
    )
}

const mapStateToProps = (state: RootState) => ({
    sideMenus: state.auth.sideMenus,
    modules: state.auth.modules
});

export default connect(mapStateToProps)(Services);